export enum EntitlementProvider {
	internal = 'internal',
	trailer = 'trailer',
}
